import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ChangeEventHandler, ForwardedRef, forwardRef, useImperativeHandle, useRef } from "react"
import { cls } from "../../../../Shared/cls"
import style from "./ToggleSwitchSlim.module.css"

export type ToggleSwitchSlimProps = {
	onChange?: ChangeEventHandler<HTMLInputElement>
	checked?: boolean
}

export type ToggleSwitchSlimRefProps = {
	toggle: () => void
}

export const ToggleSwitchSlim = forwardRef((props: ToggleSwitchSlimProps, ref: ForwardedRef<ToggleSwitchSlimRefProps>) => {
	const labelRef = useRef<HTMLLabelElement | null>(null)

	useImperativeHandle(
		ref,
		() => ({
			toggle() {
				const label = labelRef.current
				if (label) {
					label.click()
				}
			},
		}),
		[],
	)

	return (
		<label ref={labelRef} className={style.switch}>
			<input
				type={"checkbox"}
				checked={props.checked}
				onChange={props.onChange}
				readOnly={props.onChange === undefined}
			/>
			<span className={cls(style.slider, style.round)}>
				<FontAwesomeIcon className={style.iconColor} icon={faCheck} />
			</span>
		</label>
	)
})
